module.exports = __webpack_public_path__ + "assets/img/logAudit-module5-7.933d5bcf.jpg";